module.exports = __webpack_public_path__ + "img/empty-img.16c20bc2.png";